module.exports = __webpack_public_path__ + "static/media/arbaj.f93c36c2.jpg";